export default {
  name: "costDocumentListStandardFilter",
  criterions: [
    {
      monthToBack: 1,
      fromDataType: 4,
      toDataType: 0,
      value: {
        fromIsSelected: true,
        fromValue: "2021-01-01T00:00:00",
        toIsSelected: false,
        toValue: "2021-02-18T23:59:59.999",
      },
      type: "DateFromToCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 1,
      label: "Okres",
      propertyName: "Period",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: 0,
          stringKey: "SaleDate",
          stringValue: "Data sprzedaży",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "IssueDate",
          stringValue: "Data wystawienia",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "CreateDate",
          stringValue: "Data utworzenia",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: null,
      booleanExtender: null,
      value: {
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 2,
      label: "Okres po",
      propertyName: "PeriodFrom",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 250,
      value: null,
      UniqueId: null,
      type: "AutocompleteTextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 3,
      label: "Kontrahent",
      propertyName: "ContractorsAutocomplete",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 150,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 4,
      label: "Nr dokumentu",
      propertyName: "DocumentNumber",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      value: true,
      type: "BooleanCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 5,
      label: "Ukryj rozliczone",
      propertyName: "OnlyNotSettledCostDocuments",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 70,
      value: null,
      type: "TextCriterion",
      Version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 6,
      label: "Kwota",
      propertyName: "Amount",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 7,
      label: "Opis",
      propertyName: "Description",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      extension: null,
      width: 200,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: 0,
          stringKey: "00000000-0000-0000-0000-000000000000",
          stringValue: "Wszyscy",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "44b172fe-b86f-497d-8d76-8e30c02ae0b7",
          stringValue: "abala",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "af82b39d-9374-4c7a-9a17-f1f7303cd3cf",
          stringValue: "abatko",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        intKey: 0,
        stringKey: "00000000-0000-0000-0000-000000000000",
        stringValue: "Wszyscy",
        tooltipValue: "",
      },
      booleanExtender: null,
      value: {
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 8,
      label: "Wprowadzone przez",
      propertyName: "Users",
      canDelete: false,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
  ],
};
